import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { Button } from 'react-bootstrap5';

import { useContext } from 'components/Members/Programs/Views/Show/Context';

import { useNavigate } from 'react-router-dom';

import LoadingPlaceholder from 'components/new_ui/WaitLayers/LoadingPlaceholder';

export default function Body({
  description, stepId, topicId, enableChoose,
}) {
  const { dispatch, actions } = useContext();

  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();

  const onClick = () => {
    setLoading(true);

    actions.updateTopic(dispatch, stepId, topicId, () => {
      setLoading(false);
      navigate(-1, { preventScrollReset: true });
    });
  };

  return (
    <div>
      <p>{description}</p>
      {enableChoose && (
        <Button
          variant="primary"
          className="mt-3"
          onClick={onClick}
          disabled={loading}
        >
          {loading && <LoadingPlaceholder placement="inline" text=" " />}
          Choose This Topic
        </Button>
      )}
    </div>
  );
}

Body.propTypes = {
  stepId: PropTypes.string.isRequired,
  topicId: PropTypes.string.isRequired,
  enableChoose: PropTypes.bool.isRequired,
  description: PropTypes.string.isRequired,
};
